import { MutationOptions, useMutation, useQueryClient } from "react-query";
import { APIError, APIResponse, postFormData } from "../api";
import { API_URL } from "../api";

interface UpdateAccountTierVariables {
  identificationType: string;
  identityDocument: { file: File; name: string | undefined };
  utilityBill: { file: File; name: string | undefined };
  passportPhoto: { file: File; name: string | undefined };
  bvn?: string;
  address?: string;
  accountTier?: string;
}

function useUpdateAccountTier<T>(
  options?: MutationOptions<APIResponse<T>, APIError, UpdateAccountTierVariables>
) {
  const client = useQueryClient();
  const {
    isLoading: isUpdatingTier,
    isError: isTierUpdateError,
    error: tierUpdateError,
    mutate: updateAccountTier,
  } = useMutation(
    (variables: UpdateAccountTierVariables) => {
      const url = API_URL + "/account/user/account/update-account-tier";

      const formData = new FormData();
      formData.append("identificationType", variables.identificationType);
      formData.append(
        "identityDocument",
        variables.identityDocument.file,
        variables.identityDocument.name
      );
      formData.append(
        "utilityBill",
        variables.utilityBill.file,
        variables.utilityBill.name
      );
      formData.append(
        "passportPhoto",
        variables.passportPhoto.file,
        variables.passportPhoto.name
      );

      if (variables.bvn) formData.append("bvn", variables.bvn);
      if (variables.address) formData.append("address", variables.address);
      if (variables.accountTier) formData.append("accountTier", variables.accountTier);

      const headers = {
        accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      };

      return postFormData(url, formData, { headers });
    },
    {
      ...options,
      onSettled() {
        client.invalidateQueries("profile");
      },
    }
  );

  return {
    updateAccountTier,
    isUpdatingTier,
    isTierUpdateError,
    tierUpdateError,
  };
}

export default useUpdateAccountTier;
